var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api, setAuthToken } from './api';
export const authService = {
    exchangeAmeiToken(ameToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post('/getLearnerToken', {}, {
                headers: {
                    Authorization: `Bearer ${ameToken}`
                }
            });
            return response.data;
        });
    },
    authenticate(ameToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.exchangeAmeiToken(ameToken);
            // Configura o token para futuras requisições
            if (result.learner_access_token) {
                setAuthToken(result.learner_access_token);
            }
            const user = {
                almUserId: result.almUserId,
                externalId: result.externalId,
                name: result.name,
                email: result.email,
                avatar: result.avatar,
                cpf: result.cpf,
                picture: result.avatar
            };
            return { user, token: result.learner_access_token };
        });
    }
};
//# sourceMappingURL=authService.js.map